import {declension} from "../../../helpers/utils";
import NetworkService from "../../../services/network-service";

export default class CourseStatsModel {
    constructor() {
        this.courseId = craft.page.ttId;
        this.url = `${NetworkService.restSiteUrl}/1.0/courses/statistics`;

        this.totalLessons = null;
        this.lessonsPerWeek = null;
        this.peoplePerWeek = null;
        this.startDate = null;
        this.startDay = null;
        this.startMonth = null;
        this.placesLeft = null;
        this.paymentType = null;
        this.fullPrice = null;
        this.priceParts = null;
        this.priceUpfront = null;
    }

    fetch(callback) {
        const params = {};

        if (this.courseId) {
            params.ttId = this.courseId;
        }

        NetworkService.get(this.url, params)
            .then(data => {
                if (data && data.success && data.response) {
                    const {
                        frequency,
                        last_week,
                        length,
                        places,
                        start_date,
                        start_day,
                        start_month,
                        price,
                        price_parts_int,
                        price_upfront_int,
                        payment_type
                    } = data.response;

                    this.totalLessons = length;
                    this.lessonsPerWeek = frequency;
                    this.peoplePerWeek = last_week;
                    this.startDate = start_date ? new Date(start_date) : null;
                    this.startDay = start_day;
                    this.startMonth = start_month;
                    this.placesLeft = places;
                    this.paymentType = payment_type;
                    this.fullPrice = price;
                    this.priceParts = price_parts_int;
                    this.priceUpfront = price_upfront_int;
                } else {
                    console.log('Api data fetch failed. Base url responded with error.');
                }

                if (callback) {
                    callback();
                }
            }).catch(err => {
            console.error(err);
        })
    }

    get totalLessonsText() {
        if (!this.totalLessons) {
            return null;
        }

        return `${this.totalLessons} ${declension(this.totalLessons, craft.localization.occupation)}`
    }

    get lessonsPerWeekText() {
        if (!this.lessonsPerWeek) {
            return null;
        }

        const value = typeof this.lessonsPerWeek === 'string' ?
            this.lessonsPerWeek.slice(0, 1) :
            this.lessonsPerWeek;

        return `${value} ${declension(value, craft.localization.occupation)} ${craft.localization.perWeek}`;
    }

    get startDateText() {
        if (!this.startDate) {
            return null;
        }

        return `${craft.localization.start} ${this.startDate.getDate()} ${this.getWhenStartMonth(this.startDate.getMonth())}`;
    }

    get peoplePerWeekText() {
        if (!this.peoplePerWeek || this.peoplePerWeek < 3) {
            return null;
        }

        return {
            label: this.peoplePerWeek === 1 ?
                craft.localization.peoplePerWeek[0] :
                craft.localization.peoplePerWeek[1],
            value: `${this.peoplePerWeek} ${declension(this.peoplePerWeek, craft.localization.people)}`
        }
    }

    get placesLeftText() {
        if (!this.placesLeft || this.placesLeft > 3) {
            return null;
        }

        return `${this.placesLeft} ${declension(this.placesLeft, craft.localization.places)}`
    }

    get fullPriceText() {
        if (!this.fullPrice) {
            return null;
        }

        return `${this.separateThousands(this.fullPrice)} ₴`;
    }

    get pricePartsText() {
        if (!this.priceParts) {
            return null;
        }

        let value = this.priceParts;

        if (value === 666) {
            value = 667;
        }

        return `${this.separateThousands(value)} ₴`;
    }

    get upfrontDiscountText() {
        if (!this.priceUpfront || this.paymentType === 'full') {
            return null;
        }

        return `-${this.separateThousands(this.fullPrice - this.priceUpfront)} ₴`;
    }

    get finalPriceText() {
        if (!this.priceUpfront) {
            return null;
        }

        const value = this.paymentType === 'full' ? this.fullPrice : this.priceUpfront;

        return `${this.separateThousands(value)} ₴`;
    }

    separateThousands(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    getWhenStartMonth(num) {
        const months = [
            craft.localization.monthsWhen.jan,
            craft.localization.monthsWhen.feb,
            craft.localization.monthsWhen.mar,
            craft.localization.monthsWhen.apr,
            craft.localization.monthsWhen.may,
            craft.localization.monthsWhen.jun,
            craft.localization.monthsWhen.jul,
            craft.localization.monthsWhen.aug,
            craft.localization.monthsWhen.sep,
            craft.localization.monthsWhen.oct,
            craft.localization.monthsWhen.nov,
            craft.localization.monthsWhen.dec
        ];

        return months[num];
    }
}